import { Component } from '@angular/core';

@Component({
  selector: 'app-reset-password-confirm-page',
  templateUrl: './reset-password-confirm-page.component.html',
  styleUrls: ['./reset-password-confirm-page.component.scss']
})
export class ResetPasswordConfirmPageComponent {}
